
import React from 'react';
import StatusShow from '../GridStatus/StatusShow';

export default function Statuses({ data, close, patient }) {
  return (
    <>
      {
        (data.statusList && data.statusList.length !== 0) &&
        <div className="w-100 mb-4 text-center">
          {
            data.statusList.map((item, index) => {
              return(
                <StatusShow
                  key={`StatusShow_${Date.now()}_${data.id}_${item.id}`}
                  data={data}
                  item={item}
                  close={close}
                  patient={patient}
                  index={index}
                />
              )
            })
          }
        </div>
      }
    </>
  );
}
